<template>
    <div class="main">
        <c-panel title="PROGRAMAS SOCIAIS" titleIcon="fas fa-hands-helping">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Catálogo dos programas de transferência de renda e proteção social."
                description="O vínculo com cada aluno é feito na seção Programas Sociais do cadastro do aluno."></el-alert>

            <el-tabs v-model="aba" @tab-click="abaMudou">
            <el-tab-pane label="CATÁLOGO" name="catalogo">

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="10">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar programa..." @keyup.native.enter="carregar"></el-input>
                </el-col>
                <el-col :xs="24" :sm="8">
                    <el-select v-model="filtro.esfera" clearable placeholder="Esfera" style="width: 100%;" @change="carregar">
                        <el-option v-for="e in esferas" :key="e" :value="e" :label="rotulo(e)"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/programa-social/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVO PROGRAMA</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Programa</th>
                            <th style="width: 130px;">Esfera</th>
                            <th class="hidden-mobile">Órgão gestor</th>
                            <th style="width: 170px;" class="u-text-center">Frequência mínima</th>
                            <th style="width: 100px;" class="u-text-center">Situação</th>
                            <th style="width: 120px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="p in items" :key="p.id">
                            <td>{{ p.nome }}</td>
                            <td>{{ rotulo(p.esfera) }}</td>
                            <td class="hidden-mobile">{{ p.orgao_gestor || '—' }}</td>
                            <td class="u-text-center">
                                <el-tag v-if="p.exige_frequencia_minima" size="mini" type="warning">{{ p.frequencia_minima }}%</el-tag>
                                <span v-else>—</span>
                            </td>
                            <td class="u-text-center">{{ p.situacao ? 'Ativo' : 'Inativo' }}</td>
                            <td class="u-text-center acao">
                                <router-link v-if="podeEscrever" :to="'/admin/programa-social/edit/' + p.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="podeEscrever" @click="excluir(p.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="6" class="u-text-center">Nenhum programa cadastrado.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>
            </el-tab-pane>

            <!-- ==================== ALUNOS POR PROGRAMA (item 36) ==================== -->
            <el-tab-pane label="ALUNOS POR PROGRAMA" name="alunos">
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="8">
                        <el-select v-model="filtroRel.programa_social_id" clearable filterable
                            placeholder="Todos os programas" style="width: 100%;" @change="carregarRelatorio">
                            <el-option v-for="p in items" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-select v-model="filtroRel.instituicao_id" clearable filterable
                            placeholder="Todas as escolas" style="width: 100%;" @change="carregarRelatorio">
                            <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-select v-model="filtroRel.situacao" clearable placeholder="Situação do vínculo"
                            style="width: 100%;" @change="carregarRelatorio">
                            <el-option :value="1" label="Ativos"></el-option>
                            <el-option :value="0" label="Encerrados"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <div v-if="relatorio">
                    <el-row :gutter="10" class="u-mb-15">
                        <el-col v-for="r in relatorio.resumo" :key="r.programa" :xs="12" :sm="6">
                            <div class="resumo-caixa">
                                <span class="n">{{ r.ativos }}</span>
                                <span class="r">{{ r.programa }}</span>
                                <small class="u-text-muted">{{ r.total }} vínculo(s) no total</small>
                            </div>
                        </el-col>
                    </el-row>

                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Aluno</th>
                                    <th style="width: 200px;">Programa</th>
                                    <th style="width: 140px;">NIS</th>
                                    <th style="width: 200px;">Vigência</th>
                                    <th style="width: 110px;" class="u-text-center">Situação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="i in relatorio.itens" :key="i.id">
                                    <td>{{ i.aluno_nome }}</td>
                                    <td>
                                        {{ i.programa_nome }}
                                        <div v-if="i.exige_frequencia_minima">
                                            <small class="u-text-muted">exige {{ i.frequencia_minima }}% de frequência</small>
                                        </div>
                                    </td>
                                    <td>{{ i.nis || '—' }}</td>
                                    <td>
                                        {{ dataBr(i.data_inicio) }}
                                        <span v-if="i.data_fim"> a {{ dataBr(i.data_fim) }}</span>
                                    </td>
                                    <td class="u-text-center">
                                        <el-tag size="mini" :type="i.situacao ? 'success' : 'info'">
                                            {{ i.situacao ? 'Ativo' : 'Encerrado' }}
                                        </el-tag>
                                    </td>
                                </tr>
                                <tr v-if="relatorio.itens.length === 0"><td colspan="5" class="u-text-center">Nenhum aluno vinculado para os filtros informados.</td></tr>
                            </tbody>
                        </table>
                    </div>
                    <small class="u-text-muted">{{ relatorio.total }} vínculo(s) listado(s).</small>
                </div>
            </el-tab-pane>
            </el-tabs>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO G — item 36. Interface para `api/programa-social`. */
export default {
    data: () => ({
        statusList: false, filtro: { nome: '', esfera: '' }, items: [],
        esferas: ['federal', 'estadual', 'municipal'],
        aba: 'catalogo', instituicoes: [], relatorio: null,
        filtroRel: { programa_social_id: null, instituicao_id: null, situacao: 1 }
    }),
    computed: {
        podeEscrever () { return [4, 5, 6, 7].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.carregar()

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
    },
    methods: {
        abaMudou () { if (this.aba === 'alunos' && !this.relatorio) this.carregarRelatorio() },
        carregarRelatorio () {
            this.relatorio = null
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/vinculo-programa-social/relatorio`,
                this.filtroRel, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.relatorio = r.data
            }).catch(e => this.$store.commit('throwException', e))
        },
        dataBr (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]}`
        },
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/programa-social/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => { this.items = r.data.data || []; this.statusList = true })
             .catch(e => this.$store.commit('throwException', e))
        },
        rotulo (v) { return { federal: 'Federal', estadual: 'Estadual', municipal: 'Municipal' }[v] || v },
        excluir (id) {
            this.$confirm('Excluir este programa social?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/programa-social/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Programa excluído.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.resumo-caixa { border: 1px solid #dcdfe6; border-radius: 4px; padding: 10px; text-align: center; margin-bottom: 8px; }
.resumo-caixa .n { display: block; font-size: 22px; font-weight: bold; }
.resumo-caixa .r { display: block; font-size: 12px; color: #606266; }
</style>
